import { LoginResponse } from "@/api/auth/dto/login.dto";
import { QueryClient } from "@tanstack/react-query";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Role } from "../api/enums/Role";

interface Session {
  email: string;
  role: Role;
}

interface AuthState {
  session?: Session;
  expired: boolean;
}

interface AuthActions {
  logout: (queryClient?: QueryClient) => void;
  expire: () => void;
  login: (email: string, loginResponse: LoginResponse) => void;
  setNewEmail: (newEmail: string) => void;
}

export const useAuthStore = create(
  persist<AuthState & AuthActions, [], [], Pick<AuthState, "session">>(
    (set) => ({
      session: undefined,
      expired: false,
      logout: (queryClient?: QueryClient) => {
        if (queryClient) queryClient.clear();

        set(() => ({
          session: undefined,
          expired: false,
        }));
      },
      expire: () =>
        set(() => ({
          session: undefined,
          expired: true,
        })),
      login: (email, { role }) => {
        set(() => ({
          session: {
            role,
            email,
          },
          expired: false,
        }));
      },
      setNewEmail: (newEmail: string) =>
        set(({ session }) => ({
          session: session ? { ...session, email: newEmail } : undefined,
        })),
    }),
    {
      // storing zustand in local storage for persistence
      name: "auth-storage",
      // the reason a session ended only has to outlive the redirect it causes
      partialize: ({ session }) => ({ session }),
    },
  ),
);
